import request from '@/utils/request'

// 查询预设模拟卷列表
export function listPresetPapers(repoId) {
  return request({
    url: '/mock-papers/preset',
    method: 'get',
    params: repoId ? { repoId } : {}
  })
}

// 查询用户自组卷列表
export function listUserPapers(repoId) {
  return request({
    url: '/mock-papers/user',
    method: 'get',
    params: repoId ? { repoId } : {}
  })
}

// 获取试卷详情（含题目）
export function getPaperDetail(id) {
  return request({
    url: `/mock-papers/${id}`,
    method: 'get'
  })
}

// 随机组卷
export function generateCustomPaper(data) {
  return request({
    url: '/mock-papers/generate',
    method: 'post',
    data
  })
}

// 提交试卷结果
export function submitPaperResult(id, data) {
  return request({
    url: `/mock-papers/${id}/submit`,
    method: 'put',
    data
  })
}

// 保存试卷答题进度（仅更新 answerDetail，不改完成状态）
export function savePaperProgress(id, data) {
  return request({
    url: `/mock-papers/${id}/progress`,
    method: 'put',
    data
  })
}

// 删除用户自组卷
export function deleteUserPaper(id) {
  return request({
    url: `/mock-papers/${id}`,
    method: 'delete'
  })
}

// GESP模拟组卷（10判断+15单选+2编程）
export function generateGespPaper(data) {
  return request({
    url: '/mock-papers/generate-gesp',
    method: 'post',
    data
  })
}

// 获取GESP试卷详情（含判断/选择/编程题）
export function getGespPaperDetail(id) {
  return request({
    url: `/mock-papers/${id}/gesp-detail`,
    method: 'get'
  })
}

